import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import Api from '../utils/Api'

export class Subscribe extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      invalid: false,
      submitted: false
    }
    this.api = new Api()
  }

  emailIsValid = email => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  handleSubmit = async () => {
    if (this.emailIsValid(this.state.email)) {
      console.log('Valid email')

      const emailsub = await this.api.post('https://api.meetglimpse.com/api/covid/signup', {
        email: this.state.email
      })
      console.log(emailsub)
      if (emailsub.data && emailsub.data.status === 'ok') {
        this.setState({ invalid: false, submitted: true })
      } else {
        this.setState({ invalid: true, submitted: false })
      }
    } else {
      this.setState({ invalid: true, submitted: false })
    }

    setTimeout(() => {
      window.location.href = 'https://meetglimpse.com/'
    }, 900)
  }

  render() {
    return (
      <Col>
        <Row className='subscribe-row'>
          <Col className='input-col'>
            <Row className='subscribe'>
              <h6>Get alerted when new topics are impacted by Coronavirus</h6>
            </Row>
            {
              !this.state.submitted ?
              <>
                <Row className='flex-row' style={{display: 'flex'}}>
                  <Col>
                    <InputGroup className='email-input-group'>
                      <FormControl
                        placeholder='curious@me.com'
                        as='input'
                        type='email'
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                        className='email-input'
                      />
                      <InputGroup.Append className='appendix'>
                        <Button className='submit' onClick={this.handleSubmit}>Get alerts</Button>
                      </InputGroup.Append>
                    </InputGroup>
                    {
                      this.state.invalid &&
                      <p className='invalid'>Invalid email</p>
                    }
                  </Col>
                </Row>
                <Row className='mobile-submit-row'>
                  <Button className='mobile-submit' onClick={this.handleSubmit}>Get alerts</Button>
                </Row>
              </>
              :
              <Row className='flex-row success'>Success!</Row>
            }
            
          </Col>
        </Row>
      </Col>
    )
  }
}